import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import BackButton from "../../img/icons/icon_blue_back.svg";

const SettingPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <header className="border_bottom">
        <div className="inner_header">
          <Link to="/home" className="icon_left d-flex align-items-center">
            <img src={BackButton} alt="" className="img-fluid" />
            <span className="head_title">{t("sidenav.SETTING.detail")}</span>
          </Link>
        </div>
      </header>
      <div className="body_content height_vh py-4">
        <div className="inner_body">
          <div className="profile_block">
            <div className="profile_form_block">
              <ul className="list-unstyled list_profile">
                <li>
                  <Link to="/update-language">
                    <span className="icon fa fa-globe d-inline txt_lightgray p-2"></span>
                    <span className="txt">
                      {t("sidenav.LANGUAGE.detail")}{" "}
                      <span>({t("sidenav.LANGUAGE.sub-detail")})</span>
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/update-password">
                    <span className="icon fa fa-lock txt_lightgray p-2"></span>
                    <span className="txt">{t("sidenav.PASSWORD.detail")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/update-mobile">
                    <span className="icon fa fa-lock txt_lightgray p-2"></span>
                    <span className="txt">{t("sidenav.MOBILE.detail")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/update-email">
                    <span className="icon fa fa-lock txt_lightgray p-2"></span>
                    <span className="txt">{t("sidenav.EMAIL.detail")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/update-pin">
                    <span className="icon fa fa-lock txt_lightgray p-2"></span>
                    <span className="txt">{t("sidenav.ADDRESS.detail")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="#">&nbsp;</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingPage;
